import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Button,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import Tooltip from "../../components/Tooltip/Tooltip";

const sections = [
  { id: "Overview", label: "Overview" },
  {
    id: "Who are We?",
    label: "Who are We?",
  },
  {
    id: "Description of Available Grants and Eligibility",
    label: "Description of Available Grants and Eligibility",
  },

  { id: "Deadlines", label: "Deadlines" },
  { id: "Applications Instructions", label: "Applications Instructions" },
  { id: "Grant Guidelines", label: "Grant Guidelines" },
  {
    id: "Selection Criteria and Budget Considerations",
    label: "Selection Criteria and Budget Considerations",
  },
];

const columns = [
  "Salaries (example, summer salary and student workers)",
  "Small Equipment (example, scanner or iPad)",
  "Materials (example, photocopying, USB drives)",
  "Total",
];

const rows = [
  {
    name: "Six-Month",
    "Salaries (example, summer salary and student workers)": "12000",
    "Small Equipment (example, scanner or iPad)": "2000",
    "Materials (example, photocopying, USB drives)": "1000",
    Total: "15,000",
  },
  {
    name: "Twelve-Month",
    "Salaries (example, summer salary and student workers)": "24000",
    "Small Equipment (example, scanner or iPad)": "4000",
    "Materials (example, photocopying, USB drives)": "2000",
    Total: "30,000",
  },
  {
    name: "Eighteen-Month",
    "Salaries (example, summer salary and student workers)": "34000",
    "Small Equipment (example, scanner or iPad)": "4000",
    "Materials (example, photocopying, USB drives)": "2000",
    Total: "40,000",
  },
];
const formatDeadline = (date) => {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${month} ${day}${getOrdinalSuffix(day)}, ${year}`;
};
const LAST_UPDATED_DATE = "2025-07-10";

const Grants = ({ deadline }) => {
  const [activeSection, setActiveSection] = useState(null);
  const presentDate = new Date();
  const deadlineDate = new Date(deadline);
  const isExpired = presentDate > deadlineDate;

  const handleScroll = () => {
    const container = document.getElementById("scrollable-content");
    if (!container) return;

    const scrollPosition = container.scrollTop;
    const offsets = sections.map(({ id }) => {
      const el = document.getElementById(id);
      return {
        id,
        offset: el ? el.offsetTop - container.offsetTop : Infinity,
      };
    });

    const current = offsets
      .filter(({ offset }) => offset <= scrollPosition + 10)
      .pop();

    if (current && current.id !== activeSection) {
      setActiveSection(current.id);
    }
  };

  useEffect(() => {
    const container = document.getElementById("scrollable-content");
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const handleScrollToSection = (sectionId) => {
    const container = document.getElementById("scrollable-content");
    const target = document.getElementById(sectionId);
    if (!container || !target) return;

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      const yOffset = -150;
      const y =
        target.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      const scrollTop = target.offsetTop - container.offsetTop;
      container.scrollTo({ top: scrollTop, behavior: "smooth" });
    }

    setActiveSection(sectionId);
  };
  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Explore Available Grants
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The University of Southern Mississippi’s Digital Humanities Hub will be
        awarding ten grants to facilitate digital humanities projects across
        Mississippi. Recipients of these grants can use them to hire staff and
        buy equipment for projects at public institutions that help preserve and
        make available to the public documents representing Mississippi’s
        history and culture.
      </Typography>

      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Mississippi Digital Humanities Hub Digitization Grants{" "}
      </Typography>
      <Typography
        variant="body2"
        sx={(theme) => ({
          textAlign: "center",

          textTransform: "uppercase",
          fontWeight: 500,
          fontSize: "0.875rem",
          mb: 2,
          letterSpacing: "0.5px",
          color: alpha(theme.palette.primary.main, 1),
        })}
      >
        Revised:{" "}
        {new Date(LAST_UPDATED_DATE).toLocaleDateString(undefined, {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "15px",
          flexDirection: "column",
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FFD700",
            color: "#111111",
            padding: "12px 20px",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#FFB800" },
          }}
          href="https://usmforms.formstack.com/forms/mississippi_digital_humanities_hub_grants"
          target="_blank"
          disabled={isExpired}
        >
          {isExpired ? "Deadline passed" : "Apply"}
        </Button>
        {/* <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: isExpired ? "red" : "text.secondary",
            fontWeight: 500,
          }}
        >
          {isExpired
            ? "The deadline for this application has passed."
            : `Deadline: ${formatDeadline(deadlineDate)}`}
        </Typography>
        */}
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          The initial deadline to apply is September 1, 2025, and early
          applicants will get priority consideration.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "text.secondary",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {" "}
          However, if funds are available we will consider late submissions
          received before October 1.
        </Typography>{" "}
      </Box>
      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          height: { xs: "auto", md: "100vh" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 250 },
            borderRight: { xs: "none", md: "1px solid #ccc" },
            borderBottom: { md: "none", xs: "1px solid #ccc" },
            p: 2,
            position: { md: "sticky", xs: "static" },
            top: 0,
            height: { xs: "auto", md: "100vh" },
            overflowX: { xs: "auto", md: "visible" },
            overflowY: { xs: "hidden", md: "auto" },
            whiteSpace: { xs: "nowrap", md: "normal" },
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            backgroundColor: "#f9f9f9",
            zIndex: 10,
            position: "relative",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              display: { xs: "block", md: "none" },
              color: "gray",
              mb: 1,
              pl: 2,
            }}
          >
            Swipe sideways to explore all sections →
          </Typography>

          <Box
            sx={{
              position: "relative",
              width: "100%",
              overflowX: { xs: "auto", md: "visible" },
              flex: 1,
              "&::after": {
                content: '""',
                position: "absolute",
                right: 0,
                top: 0,
                height: "100%",
                width: 30,
                background:
                  "linear-gradient(to left, #f9f9f9 60%, transparent)",
                pointerEvents: "none",
                display: { xs: "block", md: "none" },
              },
            }}
          >
            <List
              sx={{
                display: "flex",
                flexDirection: { xs: "row", md: "column" },
                width: "100%",
                flex: 1,
                overflowY: { xs: "hidden", md: "auto" },
                scrollSnapType: { xs: "x mandatory", md: "none" },
                scrollPaddingX: "16px",
              }}
            >
              {sections.map((section) => (
                <ListItemButton
                  key={section.id}
                  onClick={() => handleScrollToSection(section.id)}
                  sx={{
                    minWidth: { xs: 160, md: "auto" },
                    px: 2,
                    flexShrink: 0,
                    whiteSpace: "normal",
                    scrollSnapAlign: { xs: "start", md: "none" },

                    backgroundColor:
                      activeSection === section.id ? "#ffd700" : "transparent",
                    "&:hover": {
                      backgroundColor:
                        activeSection === section.id ? "#ffd700" : "#f0f0f0",
                    },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ListItemText primary={section.label} />
                </ListItemButton>
              ))}
            </List>
          </Box>
        </Box>

        {/* Content */}
        <Box
          id="scrollable-content"
          sx={{
            flex: 1,
            p: 4,
            overflowY: "auto",
            scrollBehavior: "smooth",
            height: { xs: "auto", md: "100vh" },
          }}
        >
          {/* Slightly Smaller Header */}{" "}
          <Typography variant="h5" id="Overview" gutterBottom>
            Overview{" "}
          </Typography>
          {/* Paragraphs */}{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The Mississippi Digital Humanities Hub invites higher education
            faculty, museum personnel, teachers, and librarians at established
            Mississippi institutions with access to cultural or historical
            documents to apply for the Hub's Digitization and Digital Humanities
            Grants.{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The Digitization and Digital Humanities Grants aim to strengthen the
            public’s access to and understanding of Mississippi's history and
            culture. Projects supported by these grants should result in two
            outcomes:{" "}
          </Typography>
          {/* Numbered List 1 */}{" "}
          <Box component="ol" sx={{ pl: 4 }}>
            {" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Digitization of materials (documents or objects) that represent
                aspects of Mississippi’s cultural and historical heritage and
                have not been previously digitized. These items must be
                institutionally-held materials (at libraries, museums,
                institutional archives) and must be used with permission of the
                institution that holds the materials. Priority funding will be
                given to proposals that digitize materials that meaningfully
                tell a story important to Mississippi’s history and
                culture.{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Publication of materials through a sustainable website and
                sharing of those resources with the Mississippi Digital Library.
                We strongly encourage projects that use digital humanities
                tools—mapping, visualization, storytelling, and/or textual
                analysis—to enhance the digitized documents.{" "}
              </Typography>{" "}
            </li>{" "}
          </Box>{" "}
          <Typography variant="h5" id="Who are We?" gutterBottom>
            Who are We?{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The Mississippi Digital Humanities Hub is a three-year grant-funded
            initiative that provides support for digitization and the digital
            humanities projects in Mississippi. Funding from the National
            Historical Publications and Records Commission (NHPRC is a division
            of the National Archives and Records Administration) provides the
            Hub with resources to hold workshops, provide grants, and offer
            support. All subgrants provided by the Hub must conform to NHPRC
            guidelines. Please note that while we encourage grant recipients to
            work with the Mississippi Digital Library, Hub grants are not
            administered by the Mississippi Digital Library and all questions
            should be referred to the Hub.{" "}
          </Typography>
          {/* Subheader */}{" "}
          <Typography
            variant="h5"
            id="Description of Available Grants and Eligibility"
            gutterBottom
          >
            Description of Available Grants and Eligibility{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The Hub will award a minimum of ten grants in September 2025: two or
            more grants of no more than $15,000, up to six $30,000 grants, and
            two $40,000 grants. Smaller grants are awarded for projects that
            will take from six-to-twelve months and larger grants may be awarded
            for up to eighteen months.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            Grants must be used to pay for staffing and equipment directly
            related to digitization, dissemination, and explication of materials
            related to Mississippi history and culture. All grant activity must
            be completed by April 30, 2027, including all required reporting.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            To be eligible for a Hub grant, you must be employed by a
            Mississippi public institution or a Mississippi-based non-profit
            dedicated to preserving the culture and history of Mississippi.{" "}
          </Typography>
          {/* Bold Subheader */}{" "}
          <Typography variant="h5" id="Deadlines" gutterBottom>
            {" "}
            Deadlines{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            Grant applications received by September 1 will receive priority
            consideration; grant applications received after September 1 will be
            considered only if funds are still available. Following the
            September 1 deadline, applicants will be notified within one month
            of submission if their funds have been approved and the first
            disbursement of funds will take place in October 2025.
          </Typography>
          {/* Bold Subheader */}{" "}
          <Typography variant="h5" id="Applications Instructions" gutterBottom>
            Applications Instructions{" "}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            Applications must be submitted online via a link located on our
            website at
            <Tooltip
              keyword="https://www.ms-digital-hub.com/grants"
              url="https://www.ms-digital-hub.com/grants"
            />{" "}
            . There are six parts to the application and each part should be
            submitted in the provided space of the application. The application
            will not be considered unless all six parts are complete.
          </Typography>
          {/* Numbered List 2 */}{" "}
          <Box component="ol" sx={{ pl: 4 }}>
            {" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Applicant Name and Institutional Affiliation{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Curriculum Vitae/Resume of Primary Investigator{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Letters of authorization from agents of record. Letters of
                authorization should be secured from appropriate authorities at
                the institution that holds the documents that will be digitized,
                from the institution that will host and maintain the online site
                that publicizes the materials, and any authorities that maintain
                administrative or fiscal oversight of the project.{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              {" "}
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Proposal (10 pages) :{" "}
                <Box component="ol" type="a" sx={{ pl: 4 }}>
                  {" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include description of project, including description
                      of materials to be digitized and how the material will
                      engage a public audience. We strongly encourage
                      applications to take advantage of the digital humanities
                      to make materials not only accessible, but to help explain
                      those materials to the public. We also encourage projects
                      that constitute a coherent collection, organized around a
                      clear narrative, that can be explained to the public.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include statement of historical or cultural
                      significance.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include a statement explaining staffing needs,
                      including staff that will be hired or redirected to
                      support the project.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include a statement explaining the resources that
                      will have to be purchased to complete the project and a
                      justification for those expenses.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Should include a statement outlining what assistance is
                      needed from MDHH. The Hub has technical expertise and
                      equipment to assist grantees.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include a brief timeline. Must specify intended start
                      and end date. The grant period must start at the beginning
                      of a month and end at the end of a month, and all grant
                      materials (and required paperwork) must be completed by
                      April 30, 2027. Grants may start before disbursement of
                      funds.{" "}
                    </Typography>{" "}
                  </li>{" "}
                  <li>
                    <Typography
                      variant="body1"
                      sx={{
                        marginBottom: "30px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      Must include specific plans for providing public, online
                      access to the digitized materials and long-term plans for
                      sustaining access. (Items may be hosted locally, but these
                      plans should include providing access through the
                      Mississippi Digital Library.){" "}
                    </Typography>{" "}
                  </li>{" "}
                </Box>{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Budget. See selection criteria below for more details.{" "}
              </Typography>{" "}
            </li>{" "}
            <li>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "30px",
                  lineHeight: "1.8",
                  textAlign: "justify",
                }}
              >
                Agreement to abide by grant guidelines. See guidelines below for
                more details.{" "}
              </Typography>{" "}
            </li>{" "}
          </Box>
          {/* Bold Lower Header */}{" "}
          <Typography variant="h5" id="Grant Guidelines" gutterBottom>
            Grant Guidelines{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            Grantees agree to provide regular updates (every six months for
            one-year-or-longer grants; every three months for six-month grants)
            including a final report, maintain records of all expenditures to be
            shared with the Hub as expenses are incurred, and to conform to
            federal rules regarding appropriate use of funds. Subgrantee
            applicants must propose digitization projects consistent with NHPRC
            guidelines as outlined at
            <Tooltip
              keyword="www.archives.gov/nhprc/administer/regulations"
              url="https://www.archives.gov/nhprc/administer/regulations"
            />{" "}
            and 2CER200 (
            <Tooltip
              keyword="www.ecfr.gov/current/title-2/subtitle-A/chapter-II/part-200?toc=1"
              url="https://www.ecfr.gov/current/title-2/subtitle-A/chapter-II/part-200?toc=1"
            />
            ).
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            All digitized items must be free of copyright restrictions or, if
            copyrighted, be cleared for free, online access by the copyright
            holder.
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            Although partner institutions will have the option to host materials
            locally, we encourage all Hub grantees to make their work available
            through the Mississippi Digital Library and select materials may
            also be highlighted on The University of Southern Mississippi's Hub
            website. Although grantees may choose to work with the Mississippi
            Digital Library, please be aware that the Hub is an independent
            resource administered through the Center for Digital Humanities at
            The University of Southern Mississippi. All questions about the
            grant guidelines should be referred to the Hub.
          </Typography>
          {/* Final Bold Header */}{" "}
          <Typography
            variant="h5"
            id="Selection Criteria and Budget Considerations"
            gutterBottom
          >
            Selection Criteria and Budget Considerations{" "}
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The historical value of the collection, the thoroughness of the
            proposal, the resource poverty of the institution, regional
            representation, and synergy with the Hub’s goals and expertise (see
            overview) will be considered in evaluating requests for funding.
            Cost-matching is not required, but institutions that invest in the
            grant project will receive recognition in the evaluation process.
          </Typography>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            All funds must be used within the grant period and all expenses
            reported and accounts settled within sixty days of the end of the
            grant period. Distribution of costs for the subcontracts will not be
            restricted to the following, but we suggest that budgets follow the
            sample guidelines.
          </Typography>
          {/* MUI Table */}{" "}
          <TableContainer component={Paper} sx={{ mb: 4 }}>
            {" "}
            <Table>
              {" "}
              <TableHead>
                {" "}
                <TableRow>
                  <TableCell />
                  {columns.map((col) => (
                    <TableCell
                      key={col}
                      sx={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        fontWeight: "bold",
                      }}
                    >
                      <Typography variant="subtitle2" fontWeight="bold">
                        {col}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>{" "}
              </TableHead>{" "}
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.name}>
                    {" "}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ fontWeight: "bold" }}
                    >
                      {row.name}
                    </TableCell>
                    {columns.map((col) => (
                      <TableCell key={col}>{row[col]}</TableCell>
                    ))}
                  </TableRow>
                ))}{" "}
              </TableBody>{" "}
            </Table>{" "}
          </TableContainer>{" "}
          <Typography
            variant="body1"
            sx={{
              marginBottom: "30px",
              lineHeight: "1.8",
              textAlign: "justify",
            }}
          >
            The grant will disburse funds in six-month installments (the grantee
            budget might determine the size of disbursements). Funds will be
            disbursed electronically when possible.{" "}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="body2"
        color="#4d4d4d"
        sx={(theme) => ({
          textAlign: "center",

          textTransform: "uppercase",
          fontWeight: 500,
          fontSize: "0.875rem",
          mb: 2,
          letterSpacing: "0.2px",
          color: alpha(theme.palette.text.secondary, 0.45),
        })}
      >
        Revised:{" "}
        {new Date(LAST_UPDATED_DATE).toLocaleDateString(undefined, {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </Typography>
    </Box>
  );
};

export default Grants;
